module.exports = __webpack_public_path__ + "static/media/lcs_10y_y-1.265fd6b6.csv";